export const SimulationStatusTypes = {
  NEW: 'New',
  DONE: 'Done',
  FAILED: 'Failed',
  SKIPPED: 'Skipped',
  RUNNING: 'Running',
};

export const ApiInvocationStatus = {
  NOT_INVOKED: 'NOT_INVOKED',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',

   isComplete(status) {
    return status === this.SUCCEEDED || status === this.FAILED;
   }
};

export const URLs = {
  PROD: 'tools.profit-intelligence.selling-partners',
  PROD_: 'phoenix.profit-intelligence.selling-partners',
  ALPHA: 'tools-alpha.profit-intelligence.selling-partners',
  LOCAL: 'localhost'
};

export const LoggerEndpoints = {
  ALPHA: 'https://logs.tools-alpha.profit-intelligence.selling-partners.a2z.com/v1/log',
  PROD: 'https://logs.tools.profit-intelligence.selling-partners.a2z.com/v1/log'
};

export const SaveReportColumnDefinitions = [
  {
    id: "variable",
    header: "Report Attributes",
    cell: item => item.name || "-"
  },
  {
    id: "value",
    header: "Values",
    cell: item => item.value || "-"
  }
];

export const MapperPaginationSize = 25;

export const AccuracyGranularity = {
  COMPONENT: 'component',
  PRODUCTLINE: 'productline',
};

// Cypress user
export const TEST_USERS = [
    'svc-pi-tools-finance-readonly',
    'svc-pi-tools-admin',
    'svc-pi-tools-public',
    'svc-pi-tools-finance',
]

export const Days = [
  {
    label: '01',
    value: '01'
  },
  {
    label: '02',
    value: '02'
  },
  {
    label: '03',
    value: '03'
  },
  {
    label: '04',
    value: '04'
  },
  {
    label: '05',
    value: '05'
  },
  {
    label: '06',
    value: '06'
  },
  {
    label: '07',
    value: '07'
  },
  {
    label: '08',
    value: '08'
  },
  {
    label: '09',
    value: '09'
  },
  {
    label: '10',
    value: '10'
  },
  {
    label: '11',
    value: '11'
  },
  {
    label: '12',
    value: '12'
  },
  {
    label: '13',
    value: '13'
  },
  {
    label: '14',
    value: '14'
  },
  {
    label: '15',
    value: '15'
  },
  {
    label: '16',
    value: '16'
  },
  {
    label: '17',
    value: '17'
  },
  {
    label: '18',
    value: '18'
  },
  {
    label: '19',
    value: '19'
  },
  {
    label: '20',
    value: '20'
  },
  {
    label: '21',
    value: '21'
  },
  {
    label: '22',
    value: '22'
  },
  {
    label: '23',
    value: '23'
  },
  {
    label: '24',
    value: '24'
  },
  {
    label: '25',
    value: '25'
  },
  {
    label: '26',
    value: '26'
  },
  {
    label: '27',
    value: '27'
  },
  {
    label: '28',
    value: '28'
  },
  {
    label: '29',
    value: '29'
  },
  {
    label: '30',
    value: '30'
  },
  {
    label: '31',
    value: '31'
  }
];



// WEBPACK FOOTER //
// ./src/constants/constants.jsx